module.exports = __webpack_public_path__ + "static/media/tech.669d41cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tech.svg
// module id = 99
// module chunks = 0